import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import IResponse = ZoneIQCalibration.IResponse;

import { map } from 'rxjs/operators';
import * as _ from 'lodash';
import { IAttributeModel } from 'src/app/interfaces/attribute-model.interface';
import { IAttributeService } from 'src/app/interfaces/services/attribute-service.interface';

export class AttributeService<T> implements IAttributeService<T> {

    protected params = new HttpParams().append('syncChanges', 'true');

    constructor(
        protected readonly http: HttpClient,
        protected readonly API: string,
        private readonly entityConstructor: new (data) => T,
    ) { }

    getByParameters(params?: HttpParams) {
        return this.http.get<IResponse>(this.API, { params })
            .pipe(map(response => {
                const attributes = response.data as T[];
                return attributes.map(attribute => new this.entityConstructor(attribute));
            }));
    }

    addOrUpdate(attributesToSave: IAttributeModel[], params?: HttpParams) {
        if (!_.get(attributesToSave, 'length', 0)) {
            return;
        }
        const dataToSave = attributesToSave.map((attribute) => {
            return attribute.getPreparedData();
        });

        const headers = new HttpHeaders()
            .set('Content-Type', 'application/json');

        return this.http.post<IResponse>(this.API, dataToSave, { headers, params: params || this.params })
            .pipe(map(response => new this.entityConstructor(response.data)));
    }

    deleteAttributes(attributeIds: number[]) {
        if (!_.get(attributeIds, 'length', 0)) {
            return;
        }
        const url = `${this.API}?ids=${JSON.stringify(attributeIds)}`;
        return this.http.delete<IResponse>(url, { params: this.params });
    }
}
